import cookies from 'js-cookie';
import { getLocalStorage } from '../utils/local-storage';
import { getTujiaHostEnv } from '../tj-utils/env';
import { getPlatform } from '../tj-utils/platform';
var TUJIA_DOMAIN = 'tujia.com';
export var storageConfig = {
    // C 端用户信息
    get userId() {
        return getTujiaEnvDomain() + '_PortalContext_UserId';
    },
    get userToken() {
        return getTujiaEnvDomain() + '_PortalContext_UserToken';
    },
    // B端用户信息
    get groupGuid() {
        return getTujiaEnvDomain() + '_PortalContext_groupGuid';
    },
    get storeGuid() {
        return getTujiaEnvDomain() + '_PortalContext_storeGuid';
    },
    // 全局入离店
    get checkInDate() {
        return getTujiaEnvDomain() + '_MobileContext_StartDate';
    },
    get checkOutDate() {
        return getTujiaEnvDomain() + '_MobileContext_EndDate';
    },
    // 资源位code
    tujiaCode: 'tujia_code',
    tujiaCodeSite: 'tujia_code_site',
    // 渠道id
    channelId: 'tj_channel_id',
    // 渠道wrapperId
    channelWrapperId: 'tj_channel_wrapper_id',
    // 渠道 Token
    channelToken: 'tj_channel_token',
    // 渠道wrapperId
    openId: 'tj_open_id',
    // ab test
    abTest: 'tj_abtest',
    // device
    deviceId: '_fas_uuid',
    // auth
    auth: 'c_auth'
};
export function getTujiaEnvDomain() {
    var envDomain = 'tujia.com';
    var envInfo = getTujiaHostEnv();
    if (!envInfo.isProd) {
        envDomain = envInfo.envType + "." + envDomain;
    }
    return envDomain;
}
/**
 * 根据域名设置 cookie
 * @param {*} key
 * @param {*} value
 * @param {*} expires
 * @param {*} isTujiaEnvDomain true: fvt.tujia.com false: tujia.com
 */
export function setCookieByDomain(key, value, expires, isTujiaEnvDomain) {
    if (expires === void 0) { expires = 0; }
    if (isTujiaEnvDomain === void 0) { isTujiaEnvDomain = false; }
    var domain = isTujiaEnvDomain ? getTujiaEnvDomain() : TUJIA_DOMAIN;
    var platform = getPlatform();
    if (!value) {
        cookies.set(key, value, { domain: domain, expires: -1 });
        cookies.set(key, value, { expires: -1 });
    }
    else {
        if (platform.isTujiaAppEnv &&
            window.navigator.userAgent.toLowerCase().indexOf('iphone') > -1 &&
            [storageConfig.userId, storageConfig.userToken].indexOf(key) > -1) {
            cookies.set(key, value, { expires: expires });
        }
        else {
            cookies.set(key, value, { expires: -1 });
        }
        cookies.set(key, value, {
            domain: isTujiaEnvDomain ? getTujiaEnvDomain() : TUJIA_DOMAIN,
            expires: expires
        });
    }
}
/**
 * 获取 cookie 值
 * @param key
 */
export function getCookie(key) {
    cookies.get(key);
}
/**
 * userId
 */
export function getUserId() {
    return cookies.get(storageConfig.userId);
}
/**
 * userId
 */
export function setUserId(userId) {
    setCookieByDomain(storageConfig.userId, userId, 30, true);
}
/**
 * userToken
 */
export function getUserToken() {
    return cookies.get(storageConfig.userToken);
}
/**
 * userToken
 */
export function setUserToken(userToken) {
    setCookieByDomain(storageConfig.userToken, userToken, 30, true);
}
/**
 * 获取途家用户信息
 * 自动做0相关屏蔽处理
 */
export function getUserInfo() {
    var tjUserId = getUserId();
    var tjUserToken = getUserToken();
    if (tjUserId &&
        tjUserToken &&
        tjUserId !== '0' &&
        tjUserToken !== '00000000-0000-0000-0000-000000000000') {
        return {
            userId: tjUserId,
            userToken: tjUserToken
        };
    }
    return null;
}
/**
 * B端 groupGuid
 */
export function setGroupGuid(groupGuid) {
    setCookieByDomain(storageConfig.groupGuid, groupGuid, 7, true);
}
/**
 * B端 groupGuid
 */
export function getGroupGuid() {
    return cookies.get(storageConfig.groupGuid);
}
/**
 * B端 storeGuid
 */
export function setStoreGuid(storeGuid) {
    setCookieByDomain(storageConfig.storeGuid, storeGuid, 7, true);
}
/**
 * B端 storeGuid
 */
export function getStoreGuid() {
    return cookies.get(storageConfig.storeGuid);
}
/**
 * 获取全局 入住日期
 */
export function getStartDate() {
    return cookies.get(storageConfig.checkInDate);
}
/**
 * 设置全局 入住日期
 */
export function setStartDate(dateStr) {
    setCookieByDomain(storageConfig.checkInDate, dateStr, 7, true);
}
/**
 * 获取全局 离店日期
 */
export function getEndDate() {
    return cookies.get(storageConfig.checkOutDate);
}
/**
 * 设置全局 离店日期
 */
export function setEndDate(dateStr) {
    setCookieByDomain(storageConfig.checkOutDate, dateStr, 7, true);
}
/**
 * 设置途家code
 * @param obj
 */
export function setTujiaCode(obj) {
    setCookieByDomain(storageConfig.tujiaCode, obj, 1);
}
/**
 * 获取途家code
 */
export function getTujiaCode() {
    return cookies.get(storageConfig.tujiaCode);
}
/**
 * 获取途家站内code
 */
export function getTujiaCodeSite() {
    return cookies.get(storageConfig.tujiaCodeSite);
}
/**
 * 设置途家站内code
 * @param obj
 */
export function setTujiaCodeSite(value) {
    setCookieByDomain(storageConfig.tujiaCodeSite, value, 1);
}
/**
 * 设置途家站内第三方auth c_auth
 * @param obj
 */
export function setThirdAuth(value) {
    setCookieByDomain(storageConfig.auth, value, 1);
}
/**
 * 获取途家系统所处平台 tujia/ctrip/qunar/elong/qunar
 */
export function getChannelId() {
    return cookies.get(storageConfig.channelId);
}
/**
 * 设置途家系统所处渠道
 * @param {*} channelId 渠道值 tujia/ctrip/qunar/elong/qunar
 */
export function setChannelId(channelId) {
    setCookieByDomain(storageConfig.channelId, channelId, 7);
}
/**
 * 获取 渠道 wrapper id
 */
export function getChannelWrapperId() {
    return cookies.get(storageConfig.channelWrapperId);
}
/**
 * 设置 渠道 wrapper id
 */
export function setChannelWrapperId(value) {
    setCookieByDomain(storageConfig.channelWrapperId, value, 7);
}
/**
 * 获取渠道 Token
 */
export function getChannelToken() {
    return cookies.get(storageConfig.channelToken);
}
/**
 * 设置渠道 Token
 */
export function setChannelToken(value) {
    setCookieByDomain(storageConfig.channelToken, value, 7);
}
/**
 * 获取 openId
 */
export function getOpenId() {
    return cookies.get(storageConfig.openId);
}
/**
 * 设置 openId
 */
export function setOpenId(value) {
    setCookieByDomain(storageConfig.openId, value, 7);
}
/**
 * 获取 ABTest
 */
export function getABTest() {
    return getLocalStorage(storageConfig.abTest);
}
/**
 * 获取设备Id
 */
export function getDeviceId() {
    return cookies.get(storageConfig.deviceId);
}
/**
 * 获取设备Id
 */
export function setDeviceId(uuid) {
    setCookieByDomain(storageConfig.deviceId, uuid, 365);
}
